import HistoryListView from "./HistoryListView";

export default HistoryListView;
